// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": function componentCacheCachesGatsbyPluginOfflineAppShellJs() {
    return import("./../../.cache/caches/gatsby-plugin-offline/app-shell.js"
    /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */
    );
  },
  "component---node-modules-rocketseat-gatsby-theme-docs-core-src-templates-docs-query-js": function componentNodeModulesRocketseatGatsbyThemeDocsCoreSrcTemplatesDocsQueryJs() {
    return import("./../@rocketseat/gatsby-theme-docs-core/src/templates/docs-query.js"
    /* webpackChunkName: "component---node-modules-rocketseat-gatsby-theme-docs-core-src-templates-docs-query-js" */
    );
  },
  "component---node-modules-rocketseat-gatsby-theme-docs-core-src-templates-homepage-query-js": function componentNodeModulesRocketseatGatsbyThemeDocsCoreSrcTemplatesHomepageQueryJs() {
    return import("./../@rocketseat/gatsby-theme-docs-core/src/templates/homepage-query.js"
    /* webpackChunkName: "component---node-modules-rocketseat-gatsby-theme-docs-core-src-templates-homepage-query-js" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  }
};